import { APIClient } from "./apiCore";
import * as url from "./urls";
import { ProfileTypes } from "../data";
const api = new APIClient();

const createSubscription = (payload: any) => {
  return api.create(url.CREATE_SUBSCRIPTION, payload);
};

const createPaymentintent = (payload: any) => {
  return api.create(url.CREATE_PAYMENT_INTENT, payload);
};

const processPayment = (payload: any) => {
  const response: Promise<any> = api.create(url.PROCESS_PAYMENT, payload);
  return response;
};

const saveSubscriptionInfo = () => {
  const response: Promise<any> = api.get(url.SAVE_SUBSCRIPTION_INFO);

  return response;
};

const cancelSubscription = () => {
  const response: Promise<any> = api.get(url.CANCEL_SUBSCRIPTION);
  return response;
};

const checkPaymentDate = () => {
  const response: Promise<any> = api.get(url.CHECK_PAYMENTDATE);
  return response;
};

export {
  checkPaymentDate,
  createSubscription,
  createPaymentintent,
  processPayment,
  saveSubscriptionInfo,
  cancelSubscription,
};
